/*
  Statement date calculation is used for statement generation and email date handling
*/
import { DateTime } from 'luxon';

import { BillTiming, ReportingTimezone } from '@willow/types-iso';

export const NEXT_STATEMENT_DAY_18 = 18;
export const NEXT_STATEMENT_DAY_1 = 1;

/**
 * If due on the 25th and HELOC or Construction loan, return 1st of the same month
 * If due on the 1st, return 18th of the previous month
 * If due on any other day, return 15 days before the payment due date
 *
 * Pass `timezone` when `paymentDueDate` comes from a snapshot translated to the owner timezone —
 * the day-of-month read and the date arithmetic must run in that zone (see getNextPaymentDueDate).
 */
export function getStatementDateForPaymentDue(
  paymentDueDate: Date,
  billTiming: BillTiming = 'fixed',
  timezone: ReportingTimezone = 'UTC',
): Date {
  const paymentDueDateTime = DateTime.fromJSDate(paymentDueDate).setZone(timezone);
  if (billTiming === 'fixed') {
    // HELOC and Construction loan logic is weird
    if (paymentDueDateTime.day === 25) {
      return paymentDueDateTime.set({ day: NEXT_STATEMENT_DAY_1 }).toJSDate();
    }
    if (paymentDueDateTime.day === 1) {
      return paymentDueDateTime.set({ day: NEXT_STATEMENT_DAY_18 }).minus({ months: 1 }).toJSDate();
    }
  }
  return paymentDueDateTime.minus({ days: 15 }).toJSDate();
}
